import React from 'react';
import Slider from 'react-slick';
import { projects } from '../data/proyectsData';
import '../assets/styles/Allprojects.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const defaultImage = 'https://via.placeholder.com/600x400?text=No+Image';

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 400,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover: true,
};

const AllProjects: React.FC = () => {
  // Ordena los proyectos por fecha descendente sin mutar el array original
  const sortedProjects = [...projects].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );

  return (
    <section id="all-projects">
      <div className="allprojects-container">
        <div className="allprojects-header">
          <h1>All Projects</h1>
        </div>

        <div className="allprojects-grid">
          {sortedProjects.map((project) => (
            <div className="allproject" key={project.id}>
              <a href={project.liveLink} target="_blank" rel="noreferrer">
                <div className="allproject-carousel-container">
                  <Slider {...sliderSettings}>
                    {(project.images && project.images.length > 0
                      ? project.images
                      : [defaultImage]
                    ).map((img, index) => (
                      <div key={index}>
                        <img
                          src={img}
                          className="allproject-zoom"
                          alt={`${project.title} ${index + 1}`}
                          style={{
                            width: '100%',
                            maxHeight: '300px',
                            objectFit: 'contain',
                            display: 'block',
                            margin: '0 auto',
                          }}
                        />
                      </div>
                    ))}
                  </Slider>
                </div>
              </a>

              <div className="allproject-info">
                <h3 className="allproject-title">{project.title}</h3>
                <p className="allproject-date">
                  {new Date(project.date).toLocaleDateString()}
                </p>
                <p className="allproject-description">{project.description}</p>

                <div className="allproject-buttons">
                  {project.githubLink && (
                    <a href={project.githubLink} target="_blank" rel="noreferrer">
                      <button className="btn btn-github">GitHub</button>
                    </a>
                  )}
                  {project.liveLink && (
                    <a href={project.liveLink} target="_blank" rel="noreferrer">
                      <button className="btn btn-live">Live</button>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AllProjects;
